// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var Json_encode = require("@glennsl/bs-json/src/Json_encode.res.js");
var DataType$ReactHooksTemplate = require("./dataType.res.js");

function id(t) {
  return t.id;
}

function name(t) {
  return t.name;
}

function dataType(t) {
  return t.dataType;
}

function masked(t) {
  return t.masked;
}

function empty(param) {
  return {
          id: undefined,
          name: "",
          dataType: DataType$ReactHooksTemplate.defaultDataType,
          masked: false
        };
}

function placeholder(id) {
  return {
          id: id,
          name: "Data field #" + String(id),
          dataType: DataType$ReactHooksTemplate.defaultDataType,
          masked: false
        };
}

function setName(t, name) {
  return {
          id: t.id,
          name: name,
          dataType: t.dataType,
          masked: t.masked
        };
}

function setDataType(t, dataType) {
  return {
          id: t.id,
          name: t.name,
          dataType: dataType,
          masked: t.masked
        };
}

function setMasked(t, masked) {
  return {
          id: t.id,
          name: t.name,
          dataType: t.dataType,
          masked: masked
        };
}

function decode(json) {
  var value = Json_decode.optional((function (param) {
          return Json_decode.field("masked", Json_decode.bool, param);
        }), json);
  return {
          id: Json_decode.optional((function (param) {
                  return Json_decode.field("id", Json_decode.$$int, param);
                }), json),
          name: Json_decode.field("name", Json_decode.string, json),
          dataType: DataType$ReactHooksTemplate.decode(json),
          masked: value !== undefined ? value : false
        };
}

function encode(t) {
  return Json_encode.object_({
              hd: [
                "id",
                Json_encode.nullable((function (prim) {
                        return prim;
                      }), t.id)
              ],
              tl: {
                hd: [
                  "name",
                  t.name
                ],
                tl: {
                  hd: [
                    "data_type",
                    DataType$ReactHooksTemplate.dataTypeName(t.dataType)
                  ],
                  tl: {
                    hd: [
                      "masked",
                      t.masked
                    ],
                    tl: {
                      hd: [
                        "data_type_property_attributes",
                        DataType$ReactHooksTemplate.encode(t.dataType)
                      ],
                      tl: /* [] */0
                    }
                  }
                }
              }
            });
}

exports.id = id;
exports.name = name;
exports.dataType = dataType;
exports.masked = masked;
exports.empty = empty;
exports.placeholder = placeholder;
exports.decode = decode;
exports.setName = setName;
exports.setDataType = setDataType;
exports.setMasked = setMasked;
exports.encode = encode;
/* DataType-ReactHooksTemplate Not a pure module */
